import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import { isLTPM } from "../../../../../components/shared_components_registration"

const registration = {
  submit: (intl) => (isLTPM ? intl.formatMessage({ id: "general.submitButton" }) : "Submit"),
}

export default function TrendLabelEditor({ obs, rowStyle, adjustMetric, intl }) {
  const [label, setLabel] = useState("")
  useEffect(() => {
    setLabel(obs.label || obs.tag)
  }, [])

  return (
    <div style={rowStyle}>
      <input
        style={{ width: "100%" }}
        type={"text"}
        value={label}
        onChange={(e) => {
          e.preventDefault()
          setLabel(e.target.value)
        }}
      />
      <Button
        variant={"outline-primary"}
        className={"btn btn-sm"}
        style={{ marginLeft: "auto" }}
        onClick={(e) => {
          e.preventDefault()
          if (label !== "") {
            adjustMetric(obs, String(label), "label")
          }
        }}
      >
        {registration["submit"](intl)}
      </Button>
    </div>
  )
}
